import { render, staticRenderFns } from "./editTask.vue?vue&type=template&id=0d223496&scoped=true&"
import script from "./editTask.vue?vue&type=script&lang=js&"
export * from "./editTask.vue?vue&type=script&lang=js&"
import style0 from "./editTask.vue?vue&type=style&index=0&id=0d223496&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d223496",
  null
  
)

export default component.exports